const API = "https://jm.komerzy.com/backend/routes/api.php?url=productosapi";

// ==========================
// LISTAR
// ==========================

export const getProductos = async () => {

    const response = await fetch(`${API}&action=listar`);

    const data = await response.json();

    return data.data;
};

// ==========================
// REGISTRAR
// ==========================

export const guardarProducto = async (producto) => {

    const formData = new FormData();

    Object.keys(producto).forEach(key => {

        formData.append(key, producto[key]);
    });

    const response = await fetch(`${API}&action=registrar`,{

        method:'POST',

        body: formData
    });

    return await response.json();
};

// ==========================
// ACTUALIZAR
// ==========================

export const actualizarProducto = async (producto) => {

    const formData = new FormData();

    Object.keys(producto).forEach(key => {

        formData.append(key, producto[key]);
    });

    const response = await fetch(`${API}&action=actualizar`,{

        method:'POST',

        body: formData
    });

    return await response.json();
};

// ==========================
// ELIMINAR
// ==========================

export const eliminarProducto = async (producto) => {

    const response = await fetch(`${API}&action=eliminar`,{

        method:'PUT',

        headers:{
            'Content-Type':'application/json'
        },

        body: JSON.stringify(producto)
    });

    return await response.json();
};